import React, { useState } from 'react';
import { FaUser, FaBriefcase, FaGlobe, FaPhone, FaEnvelope } from 'react-icons/fa';
import { BASE_URL_API } from '../../configs';
import { Link } from "react-router-dom";
import { User } from '../../models';

const Profile = ({ ...props }:User) => {
    const [tab, setTab] = useState(0);
    const op = 'opacity-[0.4]';
    const cssd = 'w-[32px] h-[30px] rounded-full bg-white text-black flex justify-center items-center text-[15px]'
    let phoneNumber = props.mobileNo ?? '';
    if (props.mobileNo?.charAt(0) === '0') {
        phoneNumber = props.mobileNo.substring(1)
    }

    const urlAvatar = props.urlAvatar === '' ? BASE_URL_API + '/images/brands/dafcLogo.jpg' : BASE_URL_API + props.urlAvatar

    return (
        <>
            <div className='relative'>
                <div className='overflow-hidden relative pb-[100%]'>
                    <img className='absolute top-0 left-0 right-0 bottom-0 object-cover object-center w-full h-full rounded-t-3xl '
                         src={urlAvatar}
                         alt='profile'
                         width={600}
                         height={600}
                    />
                </div>
                <div className='relative -mt-[70px] z-10 pt-[30px] pb-4 px-4 
                bg-[linear-gradient(0deg,#292929_65%,rgba(6,6,8,0)_100%)]
                min-h-[160px] flex flex-col gap-2 justify-end '>
                    <h1 className='text-white text-[32px] leading-[1.3] font-bold'>
                        {props.firstName || 'undefined'}
                        <br/>
                        {props.lastName || 'undefined'}
                    </h1>
                    <h3 className='text-white text-[20px] font-normal italic'>
                        {props.position || 'undefined'}
                    </h3>
                </div>
            </div>
            <div className="px-4">
                <div className="flex flex-row flex-nowrap mb-4 gap-2">
                    <button
                        onClick={() => setTab(0)}
                        className={`${tab === 0 ? cssd : op} w-[32px] h-[30px] flex items-center justify-center`}
                    >
                        <FaUser className="icon"/>
                    </button>
                    <button
                        onClick={() => setTab(1)}
                        className={`${tab === 1 ? cssd : op} w-[32px] h-[30px] flex items-center justify-center`}
                    >
                        <FaBriefcase className="icon"/>
                    </button>
                    <button
                        onClick={() => setTab(2)}
                        className={`${tab === 2 ? cssd : op} w-[32px] h-[30px] flex items-center justify-center`}
                    >
                        <FaGlobe className="icon"/>
                    </button>
                    <button className="flex-1"></button>
                </div>
                {tab === 0 && (
                    <div className="font-normal font-main leading-6 text-[14px] min-h-[50px]">
                        <p>
                            <span className='font-bold pr-3 inline-flex items-baseline'>Mobile:</span>
                            <span>
                                <Link className='inline-flex flex-grow items-center' to={`tel:+84${phoneNumber}`}>
                                    {'+84 '+ phoneNumber.substring(0,3) + '.' + phoneNumber.substring(3,6) + '.' + phoneNumber.substring(6)}
                                    <FaPhone className='ml-2'/>
                                </Link>
                            </span>
                        </p>
                        <p><span className='font-bold pr-6 inline-flex items-baseline'>Email:</span>
                            <span>
                                <Link className='inline-flex flex-grow items-center' to={`mailto:${props.email}`}>
                                    {props.email ?? ' jacquelinenguyen@imexpan.net'}
                                    <FaEnvelope className='ml-2'/>
                                </Link>
                            </span>
                        </p>
                    </div>
                )}
                {tab === 1 && (
                    <div className="font-normal font-main leading-6 text-[14px] min-h-[50px]">
                        <p className="text-xl mb-2 font-extrabold" >Imex Pan Pacific Group</p>
                        <p className="">
                            <span className="font-bold pr-6 inline-flex items-baseline">Headquarter: </span>
                            <a href='https://maps.app.goo.gl/RVU69omMxTBePdGw5' target='_blank' rel="noreferrer">
                                7th Floor, Opera View Tower, 161 Dong Khoi Street, District 1, Ho Chi Minh City </a></p>
                        <p className="mb-2">
                            <span className="font-bold pr-3 inline-flex items-baseline">Contact office: </span>
                            <a href='https://maps.app.goo.gl/EB2Gi23WfGRx6CD47' target='_blank' rel="noreferrer">
                                2nd Floor, Sasco Tower, 45 Truong Son Street, Ward 2, Tan Binh District, Ho Chi Minh
                                City </a></p>
                        <p><span className="font-bold">T:</span> (84-28) 3824 8117</p>
                        <p><span className="font-bold">F:</span> (84-28) 3824 8126</p>
                    </div>
                )}
                {tab === 2 && (
                    <div className="font-normal font-main leading-6 text-[14px] min-h-[50px]">
                        <p><span className='mr-7 font-bold'>Website:</span> <a href="https://ippgroup.vn/" target='_blank'
                                                                     rel="noreferrer">https://ippgroup.vn</a></p>
                        <div className='flex items-center pt-[2px] font-bold'>Follow us:
                            <div className='flex gap-4 ml-5'>
                                {/*<a href="https://www.facebook.com/DAFC.company" target='_blank' rel="noreferrer"><img*/}
                                {/*    src={`${BASE_URL_API}/assets/icons/icon-facebook.png`} alt='Facebook' width={20}*/}
                                {/*    height={20}/></a>*/}
                                {/*<a href="https://www.instagram.com/dafc_vietnam" target='_blank' rel="noreferrer"><img*/}
                                {/*    src={`${BASE_URL_API}/assets/icons/icon-instagram.png`} alt='Instagram' width={20}*/}
                                {/*    height={20}/></a>*/}
                                {/*<a href="https://zalo.me/661854750494308935" target='_blank' rel="noreferrer"><img*/}
                                {/*    src={`${BASE_URL_API}/assets/icons/icon-zalo.png`} alt='Zalo' width={20}*/}
                                {/*    height={20}/></a>*/}
                                <a href="https://www.linkedin.com/company/imex-pan-pacific-group-ippg" target='_blank' rel="noreferrer"><img
                                    src={`${BASE_URL_API}/assets/icons/icon-in.png`} alt='Linkedin' width={20}
                                    height={20}/></a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Profile;